import brand from '@helpers/brand';
import { fonts } from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { ThemeSwitch } from '@helpers/theme';
import styled, { css } from 'styled-components';
const buttonStyles = css `
  display: flex;
  align-items: center;
  height: 100%;
  flex-shrink: 0;
  padding: 0 24px;
  border: none;
  outline: none;
  background-color: ${brand.accent.orange};
  color: ${brand.white};
  ${fonts.DaxPro.Bold};
  font-size: 22px;
  font-weight: bold;
  white-space: nowrap;
  cursor: pointer;

  &:hover,
  &:focus {
    background-color: #e65c00;
    color: #000;
    outline: none;
  }
`;
/** v1 */
const NavItem = styled.li `
  display: flex;
  align-items: stretch;
  flex-shrink: 0;
  height: 45px;

  @media ${until(Device.DesktopSmall)} {
    display: none;
  }
`;
const NavButton = styled.button `
  ${buttonStyles}
`;
/** v2 */
const Bar = styled.div `
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 45px;
  margin-left: 20px;

  @media ${from(Device.DesktopLarge)} {
    margin-left: 40px;
  }

  &[data-icon-only='true'] {
    margin-left: 50px;
  }

  &::before {
    content: '';
    position: absolute;
    z-index: -1;
    top: 0;
    left: -40px;
    width: 2000px;
    height: 100%;
    background: ${brand.white};
    clip-path: polygon(1% 0%, 100% 0px, 100% 100%, 0% 100%);
  }

  @media ${until(Device.DesktopSmall)} {
    display: none;
  }
`;
const Telephone = styled.a `
  display: flex;
  align-items: center;
  height: 100%;
  padding: 10px;
  ${ThemeSwitch({ groundforceColour: '#690' })}
  color: var(--theme);

  &:hover {
    text-decoration: none;
  }

  svg {
    width: 33px;
    height: 25px;
    margin-right: 10px;
    padding: 2px;
    padding-right: 0;
    color: var(--theme);
  }

  span {
    display: flex;
    align-items: center;
    height: 100%;
    margin: 0;
    ${fonts.DaxPro.Bold};
    font-size: 16px;
    white-space: nowrap;

    @media ${from(Device.DesktopLarge)} {
      font-size: 25px;
    }
  }

  &[data-icon-only='true'] {
    svg {
      margin-right: 0;
    }

    span {
      display: none;
    }
  }
`;
const BarButton = styled.button `
  ${buttonStyles}
  position: relative;
  z-index: 1;
  align-self: stretch;

  @media ${until(Device.DesktopLarge)} {
    &[data-compact='true'] {
      margin-left: 16px;
    }
  }
`;
export const ContactCtaStyles = {
    NavItem,
    NavButton,
    Bar,
    Telephone,
    BarButton,
};
